import { AttachType } from "models/AppModels";
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";

export default class MediaUtils {

    static AcceptImages(): string[] {
        return [
            ".png",
            ".jpg",
            ".jpeg",
            ".gif"
        ];
    }

    static AcceptAzureVideos(): string[] {
        return [
            ".ts",
            ".3gp",
            ".mpeg",
            ".flv",
            ".wmv",
            ".asf",
            ".avi",
            ".mov",
            ".mkv",
            ".mp4"
        ];
    }

    static AcceptBrowserVideosOnly(): string[] {
        return [
            ".mp4",
            ".webm",
            ".ogg"
        ];
    }

    static AcceptFiles(): string[] {
        return [
            ".pdf",
            ".doc",
            ".docx",
            ".xls",
            ".xlsx",
            ".ppt",
            ".pptx",
            ".zip",
            ".txt",
            ".csv"
        ];
    }

    static AcceptAllAttachs(): string[] {
        return MediaUtils.AcceptImages().concat(MediaUtils.AcceptAzureVideos()).concat(MediaUtils.AcceptFiles());
    }

    static getAttachTypeFromMimeType(mimeType: string): AttachType {

        if (mimeType == null || mimeType.length == 0)
            return null;

        if (mimeType.indexOf("image") > -1)
            return AttachType.Image;

        if (mimeType.indexOf("video") > -1)
            return AttachType.Video;

        return AttachType.File;
    }


    static getImageFromMimeType(mimeType: string, ext: string): string {

        if (mimeType == null || ext == null)
            return null;

        let src = "/img/contenttype/OtherDocument.png";

        if (mimeType == "application/pdf")
            src = "/img/contenttype/Pdf.png";
        else if (ext.indexOf(".doc") > -1)
            src = "/img/contenttype/Word.png";
        else if (ext.indexOf(".xls") > -1)
            src = "/img/contenttype/Excel.png";
        else if (ext.indexOf(".ppt") > -1)
            src = "/img/contenttype/PowerPoint.png";
        else if (ext.indexOf(".txt") > -1)
            src = "/img/contenttype/Txt.png";
        else if (ext.indexOf(".zip") > -1)
            src = "/img/contenttype/Zip.png";

        return src;
    }

    static isPDF(ext: string): boolean {
        return ext.indexOf(".pdf") > -1;
    }

    static isOfficeDocument(ext: string): boolean {
        return ext.indexOf(".doc") > -1 || ext.indexOf(".xls") > -1 || ext.indexOf(".ppt") > -1;
    }

    static makeOfficeViewerUrl(url: string): string {
        var fullLocation = HtmlUtils.getFullLocation();
        return HtmlUtils.isLocalhost() ? url : `https://view.officeapps.live.com/op/view.aspx?src=${fullLocation}${url}`;
    }

    static validFileInput(filename: string, accept: string | string[]) {
        if (accept == null) return true;

        const compare = typeof accept == "string" ? accept.toLowerCase().split(",") : accept;
        if (compare.length == 0) return true;

        const extension = "." + LibUtils.getFileExtension(filename);
        return compare.findIndex(x => x.startsWith("application") || x == extension) > -1;
    }
}